<script>
  import { createEventDispatcher } from "svelte";
  import { getContext } from "svelte";
  import { factoryStore } from "../store/factories.js";
  import { langTextStore } from "../store/langtexts.js";

  import { numberFormatStore } from "../store/numberFormat.js";
  const { snackbar } = getContext("app");

  const dispatch = createEventDispatcher();
  export let value;
  let valueAlternate;
  export let readonly;
  export let id = "";
  export let alternateCurrencyId = 0;
  export let alternateCurrencyRate = 1;
  export let mainCurrencyId = 0;
  export let min = null;
  export let max = null;
  function checkAndBubble() {
    //beware of duplicated function
    window.setTimeout(() => {
      var isToBig = min && min > value;
      if (isToBig) {
        value = min;
        snackbar(
          "error",
          $langTextStore.getText("general-min-value") + ":" + min
        );
      }
      var isToBig = max && max < value;
      if (isToBig) {
        value = max;
        snackbar(
          "error",
          $langTextStore.getText("general-max-value") + ":" + max
        );
      }
      bubble("change");
    }, 50);
  }
  //export let alternateCurrencySign = "";
  let valueAlternateInternal;
  let valueInternal;

  let roundingDigits = 1000000;

  function initialize() {
    valueAlternateInternal =
      Math.round((value / alternateCurrencyRate) * roundingDigits) /
      roundingDigits;
    valueInternal = value;

    valueAlternate = valueAlternateInternal;
  }
  $: initialize(value, alternateCurrencyRate);
  $: valueAlternate =
    value &&
    Math.round((value / alternateCurrencyRate) * roundingDigits) /
      roundingDigits;

  $: changeValueAlternate(valueInternal, alternateCurrencyRate);
  $: changeValue(valueAlternateInternal, alternateCurrencyRate);

  function changeValue(valueAlternateInternal, alternateCurrencyRate) {
    if (valueAlternateInternal != valueAlternate) {
      if (alternateCurrencyRate == null || alternateCurrencyRate == undefined) {
        alternateCurrencyRate = 1;
      }
      valueAlternate = valueAlternateInternal;
      valueInternal =
        Math.round(
          valueAlternateInternal * alternateCurrencyRate * roundingDigits
        ) / roundingDigits;
      value = valueInternal || 0;
    }
  }

  function changeValueAlternate(valueInternal, alternateCurrencyRate) {
    if (valueInternal != value) {
      if (alternateCurrencyRate == null || alternateCurrencyRate == undefined) {
        alternateCurrencyRate = 1;
      }
      value = valueInternal;
      valueAlternateInternal =
        Math.round((valueInternal / alternateCurrencyRate) * roundingDigits) /
        roundingDigits;
      valueAlternate = valueAlternateInternal || 0;
    }
  }

  function bubble(type) {
    try {
      dispatch(type);
    } catch (s) {
      debugger;
    }
  }
  let timer;
  function bubbleDebounced(type) {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      bubble(type);
    }, 50);
  }

  function getCurrency(theCurrencyId) {
    var currencyNameObj = $factoryStore.currencies.find(
      (c) => c.id == theCurrencyId
    );
    if (currencyNameObj != null) {
      return currencyNameObj.htmlCode;
    }
    return "";
  }
</script>

{#if !alternateCurrencyId || alternateCurrencyId == 0 || alternateCurrencyId == mainCurrencyId || $factoryStore.currentCalculator.inputCurrency != "alternate"}
  <span class="prelabel">{@html getCurrency(mainCurrencyId)}</span>
  {#if readonly}
    <input
      {id}
      class="prelabel--has"
      type="text"
      value={$numberFormatStore.formatNumber(valueInternal)}
      {readonly}
      class:readonly
      disabled={readonly}
    />
  {:else}
    <input
      {id}
      class="prelabel--has"
      type="number"
      on:keyup={() => {
        bubbleDebounced("keyup");
      }}
      on:keydown={() => {
        bubbleDebounced("keydown");
      }}
      on:change={() => {
        checkAndBubble();
        bubble("change");
      }}
      on:focusout={() => {
        bubble("focusout");
      }}
      on:focusin={() => {
        bubble("focusin");
      }}
      on:focus={(e) => {
        e.target.select();
      }}
      step=".000001"
      bind:value
      {readonly}
      class:readonly
    />
  {/if}

  <nobr class="prelabel-text-container"
    ><span class="prelabel-text">{@html getCurrency(alternateCurrencyId)}</span
    ><span>{$numberFormatStore.formatNumber(valueAlternate)}</span></nobr
  >
{/if}

{#if alternateCurrencyId && alternateCurrencyId > 0 && $factoryStore.currencies.length > 0 && alternateCurrencyId != mainCurrencyId && $factoryStore.currentCalculator.inputCurrency == "alternate"}
  <span class="prelabel">{@html getCurrency(alternateCurrencyId)}</span>
  {#if readonly}
    <input
      {id}
      class="prelabel--has"
      type="text"
      value={$numberFormatStore.formatNumber(valueAlternate)}
      {readonly}
      class:readonly
      disabled={readonly}
    />
  {:else}
    <input
      {id}
      class="prelabel--has"
      type="number"
      on:keyup={() => {
        bubbleDebounced("keyup");
      }}
      on:keydown={() => {
        bubbleDebounced("keydown");
      }}
      on:change={() => {
        bubble("change");
      }}
      on:focusout={() => {
        bubble("focusout");
      }}
      on:focusin={() => {
        bubble("focusin");
      }}
      on:focus={(e) => {
        e.target.select();
      }}
      step=".000001"
      bind:value={valueAlternateInternal}
    />
  {/if}
  <nobr class="prelabel-text-container"
    ><span class="prelabel-text">{@html getCurrency(mainCurrencyId)}</span><span
      >{$numberFormatStore.formatNumber(value)}</span
    ></nobr
  >
{/if}

<!-- <span on:click={()=>currentCurrency='base'}>  {mainCurrencyName}</span>
    <span on:click={()=>currentCurrency='alternate'}>   {alternateCurrencyName}</span><br> -->
<style>
  /* .prelabel.euro:before {
    content: '\20AC';
}

.prelabel.yuan:before {
    content: '\5143';
}

.prelabel.dollar:before {
    content: '\5143';
} */
</style>
